import axios from 'axios';

const url = '/api/v1/external/auth0';

class LocalAuth0Service {

    static deleteUser(userId, token) {
        
        //console.log('LocalAuth0Service.deleteUser: Started.')
        
        return axios.delete(url + "/clients/" + userId, {
            headers: {Authorization: `Bearer ${token}`}
        })
    }

    static updateUser(token, updates) {
        
        // console.log("LocalAuth0Service.updateUser")
        // console.log(updates)
        
        return axios.put(url + '/users', updates, {
            headers: {Authorization: `Bearer ${token}`}
        })
    }

}

export default LocalAuth0Service; 